import { useTranslation } from 'react-i18next';

import { PageTitle } from '@app/core';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { UniversalLoginForm } from '@app/auth';

import { AuthPane } from './AuthPane';
import { LinkSentence } from './components/LinkSentence';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  h1: {
    ...theme.fonts.h3,
  },
}));

export const LoginParticipant = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <AnalyticsCategoryProvider category={Categories.LOGIN}>
      <AuthPane>
        <PageTitle title={t('auth.login.metaTitle')} />
        <h1 className={classes.h1}>{t('auth.login.title')}</h1>

        <UniversalLoginForm redirectUrl="/" />
        {/* t('auth.login.join') */}
        <LinkSentence text="auth.login.join" to="/registration" />
      </AuthPane>
    </AnalyticsCategoryProvider>
  );
};
